import { app } from "@microsoft/teams-js";

/**
 * Opens a URL outside the Teams tab iframe. Hosted Teams often blocks
 * plain window.open; app.openLink is the supported approach when the SDK is ready.
 *
 * @param {string | null | undefined} url
 */
export function openExternalUrl(url) {
  if (!url || typeof url !== "string") {
    return;
  }
  const trimmed = url.trim();
  if (!trimmed) {
    return;
  }
  void app.openLink(trimmed).catch(() => {
    window.open(trimmed, "_blank", "noopener,noreferrer");
  });
}
